import { Column } from '@silevis/reactgrid';

export const getRolesTabColumns = (): Column[] => [
  { columnId: 'name', width: 500 },
  { columnId: 'hourlyRate', width: 200 },
  { columnId: 'action', width: 100 },
];
